import { createReducer } from "reduxsauce";
import ReducerRegister from "../../../../ReducerRegister";
import { ActionTypes } from "../../../../actionTypes/screens/admin/agent/bankcard/EditActionTypes";
import EditService from "../../../../../services/screens/admin/agent/bankcard/EditService"
import AsyncActionReducers from "../../../../AsyncActionReducers";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.agent.bankcard.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            EditService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveBankCardAsync: (vo) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.SAVE_BANK_CARD_ASYNC, vo });
            
            EditService.saveBankCard(vo,
                response => {
                    dispatch(Actions.saveBankCardSuccess(response));
                },
                error => {
                    dispatch(Actions.saveBankCardFailure(error));
                }
            );
        };
    },

    saveBankCardSuccess: data => ({
        type: ActionTypes.SAVE_BANK_CARD_SUCCESS,
        parentType: ActionTypes.SAVE_BANK_CARD_ASYNC,
        data
    }),

    saveBankCardFailure: error => ({
        type: ActionTypes.SAVE_BANK_CARD_FAILURE,
        parentType: ActionTypes.SAVE_BANK_CARD_ASYNC,
        error
    }),

    create: () => ({
        type: ActionTypes.CREATE
    })

};

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
    bankCardInfo: null,
};

/* ------------- Reducers ------------- */
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, bankCardInfo: data.bankCard };
};

const newReducer = (state) => {
    return { ...state, bankCardInfo: {} };
};

/* ------------- Hookup Reducers To Types ------------- */

const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_BANK_CARD_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_BANK_CARD_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_BANK_CARD_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE]: newReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };